import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'zeudy-timestamp',
  styleUrl: 'zeudy-timestamp.scss',
  shadow: false,
})
export class zeudyTimestamp {
  @Prop() time: string;

  handleClick(e) {
    e.preventDefault();
    const player = document.body.querySelector('zeudy-player');
    if (!player) return;
    player.goToAndPlay(this.timeToSeconds(this.time));
  }

  /**
   * Formats Timestamp to seconds.
   * I.E. 12:34 to number of seconds.
   */
  timeToSeconds(time) {
    let pieces = time.split(':');
    let seconds;
    if (pieces.length > 1) {
      seconds = parseInt(pieces[0]) * 60;
    }
    return parseInt(pieces[1]) + parseInt(seconds);
  }

  render() {
    return (
      <a href="#" class="zeudy-timestamp" onClick={e => this.handleClick(e)}>
        <slot>{this.time}</slot>
      </a>
    );
  }
}
